module.exports = __webpack_public_path__ + "img/girl_3.47bfdc67.svg";